"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _core = require("@chakra-ui/core");

var _reactSlideshowImage = require("react-slideshow-image");

var _styles = require("./styles");

var _faImages = require("@fortawesome/pro-regular-svg-icons/faImages");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    py: 10,
    justifyContent: "center",
    alignItems: "center",
    w: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faImages.faImages,
    size: "6x"
  }));
};

var Image = function Image(_ref) {
  var url = _ref.url,
      mobileUrl = _ref.mobileUrl,
      alt = _ref.alt,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mobileUrl ? /*#__PURE__*/_react["default"].createElement("picture", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("source", {
    srcSet: url,
    media: "(min-width: 768px)"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: mobileUrl,
    alt: alt,
    title: title
  })) : /*#__PURE__*/_react["default"].createElement("img", {
    src: url,
    alt: alt,
    title: title
  }));
};

var ImageContent = function ImageContent(_ref2) {
  var _ref2$image = _ref2.image,
      _ref2$image$url = _ref2$image.url,
      url = _ref2$image$url === void 0 ? '' : _ref2$image$url,
      _ref2$image$mobileUrl = _ref2$image.mobileUrl,
      mobileUrl = _ref2$image$mobileUrl === void 0 ? '' : _ref2$image$mobileUrl,
      _ref2$image$alt = _ref2$image.alt,
      alt = _ref2$image$alt === void 0 ? '' : _ref2$image$alt,
      _ref2$image$title = _ref2$image.title,
      title = _ref2$image$title === void 0 ? '' : _ref2$image$title,
      _ref2$image$link = _ref2$image.link,
      link = _ref2$image$link === void 0 ? '' : _ref2$image$link,
      _ref2$image$openInNew = _ref2$image.openInNewTab,
      openInNewTab = _ref2$image$openInNew === void 0 ? false : _ref2$image$openInNew;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, link.length > 0 ? /*#__PURE__*/_react["default"].createElement(_core.Link, {
    rel: openInNewTab ? 'nofollow noreferrer' : '',
    href: link,
    target: openInNewTab ? '_blank' : '_self'
  }, /*#__PURE__*/_react["default"].createElement(Image, {
    title: title.length > 0 ? title : alt,
    alt: alt,
    url: url,
    mobileUrl: mobileUrl
  })) : /*#__PURE__*/_react["default"].createElement(Image, {
    title: title.length > 0 ? title : alt,
    alt: alt,
    url: url,
    mobileUrl: mobileUrl
  }));
};

var CarouselComponent = function CarouselComponent(_ref3) {
  var _window, _window$location;

  var _ref3$state = _ref3.state,
      _ref3$state$slideDura = _ref3$state.slideDuration,
      slideDuration = _ref3$state$slideDura === void 0 ? 5000 : _ref3$state$slideDura,
      _ref3$state$transitio = _ref3$state.transition,
      transition = _ref3$state$transitio === void 0 ? 'slide' : _ref3$state$transitio,
      _ref3$state$transitio2 = _ref3$state.transitionDuration,
      transitionDuration = _ref3$state$transitio2 === void 0 ? 1000 : _ref3$state$transitio2,
      _ref3$state$autoplay = _ref3$state.autoplay,
      autoplay = _ref3$state$autoplay === void 0 ? false : _ref3$state$autoplay,
      _ref3$state$pauseOnHo = _ref3$state.pauseOnHover,
      pauseOnHover = _ref3$state$pauseOnHo === void 0 ? true : _ref3$state$pauseOnHo,
      _ref3$state$showIndic = _ref3$state.showIndicators,
      showIndicators = _ref3$state$showIndic === void 0 ? false : _ref3$state$showIndic,
      _ref3$state$indicator = _ref3$state.indicatorsPosition,
      indicatorsPosition = _ref3$state$indicator === void 0 ? 'below' : _ref3$state$indicator,
      _ref3$state$indicator2 = _ref3$state.indicatorsColour,
      indicatorsColour = _ref3$state$indicator2 === void 0 ? '#000' : _ref3$state$indicator2,
      _ref3$state$showArrow = _ref3$state.showArrows,
      showArrows = _ref3$state$showArrow === void 0 ? true : _ref3$state$showArrow,
      _ref3$state$arrowsCol = _ref3$state.arrowsColour,
      arrowsColour = _ref3$state$arrowsCol === void 0 ? '#bababa' : _ref3$state$arrowsCol,
      _ref3$state$images = _ref3$state.images,
      images = _ref3$state$images === void 0 ? [] : _ref3$state$images,
      _ref3$state$selectedI = _ref3$state.selectedImageIndex,
      selectedImageIndex = _ref3$state$selectedI === void 0 ? 0 : _ref3$state$selectedI,
      isEditMode = _ref3.isEditMode,
      onChange = _ref3.onChange;
  var slideRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var transitionProperties = {
    duration: parseInt(slideDuration),
    transitionDuration: parseInt(transitionDuration),
    autoplay: !isEditMode && autoplay,
    indicators: showIndicators,
    arrows: showArrows,
    canSwipe: !isEditMode,
    pauseOnHover: pauseOnHover,
    easing: 'cubic',
    prevArrow: /*#__PURE__*/_react["default"].createElement("div", {
      className: "nav default-nav",
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: arrowsColour
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
    }))),
    nextArrow: /*#__PURE__*/_react["default"].createElement("div", {
      className: "nav default-nav",
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: arrowsColour
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
    })))
  };
  var Components = {
    fade: _reactSlideshowImage.Fade,
    slide: _reactSlideshowImage.Slide
  };
  var CarouselComponent = isEditMode ? _reactSlideshowImage.Slide : Components[transition];
  (0, _react.useEffect)(function () {
    if (slideRef.current && isEditMode && selectedImageIndex > 0 && isLoaded) {
      slideRef.current.goTo(parseInt(selectedImageIndex, 10));
    } else {
      // reset the selected image index to 0 on load
      onChange({
        selectedImageIndex: 0
      });
      setIsLoaded(true);
    }
  }, [selectedImageIndex, isEditMode]);
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (images === null || images === void 0 ? void 0 : images.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_styles.CarouselStyles, {
    indicatorsPosition: indicatorsPosition,
    indicatorsColour: indicatorsColour,
    className: "content__carousel"
  }, /*#__PURE__*/_react["default"].createElement(CarouselComponent, _extends({
    ref: slideRef
  }, transitionProperties), images.map(function (image, idx) {
    return /*#__PURE__*/_react["default"].createElement(_styles.ImageStyles, {
      onClick: function onClick(e) {
        if (isEditMode) {
          e.preventDefault();
          onChange({
            selectedImageIndex: idx
          });
        }
      },
      selectedImage: isEditMode && selectedImageIndex === idx,
      key: "carousel_img_".concat(idx, "_").concat(image.url)
    }, image !== null && image !== void 0 && image.url && (image === null || image === void 0 ? void 0 : image.url.length) > 0 ? /*#__PURE__*/_react["default"].createElement(ImageContent, {
      image: image
    }) : /*#__PURE__*/_react["default"].createElement(Icon, null));
  }))) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var _default = CarouselComponent;
exports["default"] = _default;